import React from "react"

import { AppRetailerBlockContainer } from "@components/DataBlocks"


export default function sitesColumn() {
	return {
		name: "id_site_translation", label: "Sites",
		options: {
			headerAlign: "left",
			customBodyRowRenderLite: (_, { sitesTranslationName }) => <AppRetailerBlockContainer rows={sitesTranslationName}/>
		}
	}
}